window.Theme = window.Theme || {};
Theme.Product = (() => {
  // let productSlider, productThumbSlider; // already declared globally in theme-scripts.liquid
  let currentVideo = null;

  const getMousePos = (e) => {
    var pos = e.currentTarget.getBoundingClientRect();
    return {
      x: e.clientX - pos.left,
      y: e.clientY - pos.top,
    };
  };

  function pauseMedia(container) {
    container.querySelectorAll('.yv-youtube-video').forEach(video =>
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    );
    container.querySelectorAll('.yv-vimeo-video').forEach(video =>
      video.contentWindow.postMessage('{"method":"pause"}', '*')
    );
    container.querySelectorAll('video').forEach(video => video.pause());
  }

  function initProductSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        productSlider?.destroy();
      }
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productSlider = new Flickity(sliderMain, options);
        setTimeout(() => productSlider.resize(), 300);
      }
    }

    if (productSlider) {
      productSlider.on('change', function () {
        pauseMedia(productSlider.element);
      });
    }
  }

  function initProductThumbSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-thumb-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-thumb-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider?.destroy();
      }
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider = new Flickity(sliderMain, options);
        setTimeout(() => productThumbSlider.resize(), 300);
      }
    }

    if (productThumbSlider) {
      productThumbSlider.on('change', function () {
        pauseMedia(productThumbSlider.element);
      });
    }
  }

  function findVisibleItems() {
    let mainSliderParent = document.getElementById('yv-product-gallery-slider');
    if (mainSliderParent) {
      let elements = mainSliderParent.getElementsByClassName('gallery-main-item');
      let thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');

      window.addEventListener('scroll', () => {
        Array.from(elements).forEach(item => {
          if (isOnScreen(item)) {
            let relatedThumb = mainSliderParent.querySelector('.gallery-thumbs-item[data-image="' + item.id + '"]');
            if (relatedThumb) {
              Array.from(thumbs).forEach(thumb => thumb.classList.remove('active'));
              relatedThumb.classList.add('active');
            }
          }
        });
      });
    }
    let mainTabsContent = document.getElementById('yvProductFeatureListwrapper');
    if (mainTabsContent) {
      let contentTabs = document.getElementsByClassName('yv-product-feature');
      window.addEventListener('scroll', function (event) {
        Array.from(contentTabs).forEach(function (item) {
          if (isOnScreen(item)) {
            let headTabs = document.getElementsByClassName('feature-link');
            Array.from(headTabs).forEach(function (head) {
              head.parentNode.classList.remove('active');
            });
            var relatedHead = document.querySelector('.feature-link[href="#' + item.id + '"]');
            if (relatedHead) {
              relatedHead.parentNode.classList.add('active');
            }
          }
        });
      });
    }
  }

  function sizeChart() {
    let sizeChartInit = document.querySelectorAll('.sizeChart-label');
    let sizeChartModel = document.getElementById('sizeChartModel');

    if (sizeChartInit && sizeChartModel) {
      let sizeChartClose = sizeChartModel.querySelector('#sizeChartClose');
      sizeChartInit.forEach(label => {
        label.addEventListener("click", e => {
          e.preventDefault();
          $(sizeChartModel).fadeIn(100);
          document.body.classList.add('sizeChartOpen');
          sizeChartClose.focus();
        });
      });
      sizeChartClose.addEventListener("click", () => {
        document.body.classList.remove('sizeChartOpen');
        $(sizeChartModel).fadeOut(100);
      });
    }
  }

  function initStickyAddToCart() {
    let mainProductForm = document.querySelector('.main-product-form');
    let stickyBar = document.getElementById('yvProductStickyBar');

    if (mainProductForm && stickyBar) {
      window.addEventListener('scroll', () => {
        if (isOnScreen(mainProductForm, true) || window.scrollY < mainProductForm.offsetTop) {
          stickyBar.classList.remove('show');
        } else {
          stickyBar.classList.add('show');
        }
      });
    }
  }

  function onReadyEvent() {
    setTimeout(function () {
      var thumbnails = document.querySelector('.yv-product-gallery-thumbs-container');
      var lastKnownY = window.scrollY;
      var currentTop = 0;
      if (thumbnails) {
        var initialTopOffset = parseInt(window.getComputedStyle(thumbnails).top);
        window.addEventListener('scroll', function (event) {
          var bounds = thumbnails.getBoundingClientRect(),
            maxTop = bounds.top + window.scrollY - thumbnails.offsetTop + initialTopOffset,
            minTop = thumbnails.clientHeight - window.innerHeight;
          if (window.scrollY < lastKnownY) {
            currentTop -= window.scrollY - lastKnownY;
          } else {
            currentTop += lastKnownY - window.scrollY;
          }
          currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopOffset);
          lastKnownY = window.scrollY;
          thumbnails.style.top = "".concat(currentTop, "px");
        });
      }
    }, 1000);

    jQuery('body').on('click', '.gallery-thumbs-item', function (e) {
      e.preventDefault();
      var destination = jQuery(this).attr('data-image');
      var top = jQuery('.shopify-section-main-header').height() + 10;
      if (jQuery('#' + destination + '.gallery-main-item').length > 0) {
        jQuery('html,body').animate({ scrollTop: (jQuery('#' + destination + '.gallery-main-item').offset().top) - top });
      }
    });

    jQuery('body').on('click', '.pdp-view-close', function (e) {
      e.preventDefault();
      jQuery('#yvProductStickyBar').remove();
    });

    jQuery('body').on('click', '.feature-link', function (e) {
      e.preventDefault();
      let destination = jQuery(this).attr('href');
      let top = jQuery('.shopify-section-main-header').height() + 90;
      if (jQuery(destination).length > 0) {
        jQuery('html,body').animate({ scrollTop: (jQuery(destination).offset().top) - top });
      }
    });

    jQuery('body').on('change', '.sticky-bar-product-options', function () {
      let _section = jQuery(this).closest('.shopify-section');
      let option = jQuery(this).attr('data-name');
      let value = jQuery(this).val();
      let mainOption = _section.find('.productOption[name="' + option + '"]');
      if (mainOption.is(':radio')) {
        _section.find('.productOption[name="' + option + '"][value="' + CSS.escape(value) + '"]').attr('checked', true).trigger('click');
      } else {
        mainOption.val(value);
        let sectionId = document.querySelector('#' + _section.attr('id'));
        if (sectionId) {
          let optionSelector = document.querySelector('.productOption[name="' + option + '"]');
          if (optionSelector) {
            optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    if (typeof fancySelector !== 'undefined') {
      Fancybox.bind(fancySelector, {
        touch: false,
        thumbs: {
          autoStart: true
        },
        on: {
          load: () => pauseMedia(document),
          done: () => pauseMedia(document)
        },
        Toolbar: {
          display: ["close"]
        }
      });
    }
  }

  function productZoomInit() {
    $('.yv-product-zoom').mouseenter(function (e) {
      $('.yv-product-zoom').removeClass('show');
      if ($(window).width() > 1021) {
        $(this).addClass('show');
      }
    });
    $('.yv-product-zoom').mousemove(function (e) {
      if ($(window).width() > 1021) {
        let t = getMousePos(e);
        this.querySelector('.gallery-cursor').style.translate = `${t.x}px ${t.y}px`;
      }
    });
    $('.yv-product-zoom').mouseleave(function (e) {
      $('.yv-product-zoom').removeClass('show');
    });
  }

  function load3DModel() {
    if (!window.Shopify) return;

    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: () => {
          if (!window.ShopifyXR || typeof window.ShopifyXR.addModels !== 'function') {
            document.addEventListener('shopify_xr_initialized', () => {
              load3DModel();
            });
            return;
          }

          document.querySelectorAll('[id^="product3DModel-"]').forEach((model) => {
            window.ShopifyXR.addModels(JSON.parse(model.textContent));
          });
          window.ShopifyXR.setupXRElements();
        }

      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: () => {
          document.querySelectorAll('.yv-product-model-item').forEach((model) => {
            let model3D = model.querySelector('model-viewer');
            model.modelViewerUI = new Shopify.ModelViewerUI(model3D);
            model3D.addEventListener('shopify_model_viewer_ui_toggle_play', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.remove('hidden'));
              if (productSlider) {
                productSlider.options.draggable = false;
                productSlider.updateDraggable();
              }
            });
            model3D.addEventListener('shopify_model_viewer_ui_toggle_pause', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.add('hidden'));
              if (productSlider) {
                productSlider.options.draggable = true;
                productSlider.updateDraggable();
              }
            });
            model.querySelectorAll('.close-product-model').forEach(el => {
              el.addEventListener('click', () => model.modelViewerUI.pause());
            });
          });
        }
      }
    ]);
  }

  function initThumbNav(section = document) {
    let thumbContainers = section.querySelectorAll('[data-thumb-nav-for]');
    if (!thumbContainers.length) return;

    thumbContainers.forEach(function (thumbContainer) {
      let mainSliderSelector = thumbContainer.getAttribute('data-thumb-nav-for');
      if (!mainSliderSelector) return;

      let mainSlider = section.querySelector(mainSliderSelector) || document.querySelector(mainSliderSelector);
      if (!mainSlider || !window.Flickity || typeof window.Flickity.data !== 'function') return;

      let mainSliderInstance = window.Flickity.data(mainSlider);
      if (!mainSliderInstance && typeof productSlider !== 'undefined' && productSlider && productSlider.element === mainSlider) {
        mainSliderInstance = productSlider;
      }
      if (!mainSliderInstance) return;

      let thumbWrapper = thumbContainer.closest('.yv-product-small-slider-container');
      let mainWrapper = thumbContainer.closest('.main-slider-wrapper');
      let preferredAxis = (mainWrapper && mainWrapper.classList.contains('thumbnail-position-bottom')) ? 'x' : 'y';
      let SCROLL_PADDING = 4;

      function getThumbItems() {
        return Array.from(thumbContainer.querySelectorAll('.yv-product-slider-item'));
      }

      function getScrollAxis() {
        if (!thumbWrapper) return preferredAxis;

        let overflowX = thumbWrapper.scrollWidth - thumbWrapper.clientWidth;
        let overflowY = thumbWrapper.scrollHeight - thumbWrapper.clientHeight;
        let canScrollX = overflowX > 1;
        let canScrollY = overflowY > 1;

        if (canScrollX && !canScrollY) return 'x';
        if (canScrollY && !canScrollX) return 'y';
        if (canScrollX && canScrollY) return overflowX >= overflowY ? 'x' : 'y';
        return preferredAxis;
      }

      function canScrollOnAxis(axis) {
        if (!thumbWrapper) return false;
        if (axis === 'x') return (thumbWrapper.scrollWidth - thumbWrapper.clientWidth) > 1;
        return (thumbWrapper.scrollHeight - thumbWrapper.clientHeight) > 1;
      }

      function getRenderableThumbItems() {
        return getThumbItems().filter(function (item) {
          return isRenderableThumbItem(item);
        });
      }

      function isRenderableThumbItem(item) {
        if (!item || !item.getClientRects || item.getClientRects().length === 0) return false;
        let style = window.getComputedStyle(item);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }

      function getMediaIdFromMainCell(cell) {
        if (!cell || !cell.id) return '';
        if (cell.id.indexOf('media-main-') === 0) return cell.id.replace('media-main-', 'media-');
        if (cell.id.indexOf('media-') === 0) return cell.id;
        return '';
      }

      function getThumbByMediaId(mediaId) {
        if (!mediaId) return null;
        let matchedThumb = thumbContainer.querySelector('.yv-product-slider-item[data-image="' + mediaId + '"]');
        return isRenderableThumbItem(matchedThumb) ? matchedThumb : null;
      }

      function getCurrentMainCell(index) {
        if (mainSliderInstance.selectedElement) return mainSliderInstance.selectedElement;
        if (mainSliderInstance.selectedElements && mainSliderInstance.selectedElements[0]) {
          return mainSliderInstance.selectedElements[0];
        }

        if (typeof index === 'number' && typeof mainSliderInstance.getCellElements === 'function') {
          return mainSliderInstance.getCellElements()[index] || null;
        }

        return null;
      }

      function getThumbOffsetOnAxis(targetThumb, axis) {
        let offset = axis === 'x' ? targetThumb.offsetLeft : targetThumb.offsetTop;
        let node = targetThumb.offsetParent;

        while (node && node !== thumbWrapper) {
          offset += axis === 'x' ? node.offsetLeft : node.offsetTop;
          node = node.offsetParent;
        }

        if (node === thumbWrapper) return offset;

        let wrapperRect = thumbWrapper.getBoundingClientRect();
        let itemRect = targetThumb.getBoundingClientRect();
        let wrapperLayoutSize = axis === 'x' ? thumbWrapper.clientWidth : thumbWrapper.clientHeight;
        let wrapperRectSize = axis === 'x' ? wrapperRect.width : wrapperRect.height;
        let scale = wrapperLayoutSize > 0 ? wrapperRectSize / wrapperLayoutSize : 1;
        if (!scale || !isFinite(scale)) scale = 1;

        let currentScroll = axis === 'x' ? thumbWrapper.scrollLeft : thumbWrapper.scrollTop;
        let rectStart = axis === 'x'
          ? itemRect.left - wrapperRect.left
          : itemRect.top - wrapperRect.top;

        return currentScroll + rectStart / scale;
      }

      function getThumbBoundsOnAxis(targetThumb, axis) {
        let start = getThumbOffsetOnAxis(targetThumb, axis);
        let size = axis === 'x' ? targetThumb.offsetWidth : targetThumb.offsetHeight;

        return {
          start: start,
          end: start + size
        };
      }

      function getFirstVisibleThumbInfo() {
        if (!thumbWrapper) return null;

        let axis = getScrollAxis();
        let currentScroll = axis === 'x' ? thumbWrapper.scrollLeft : thumbWrapper.scrollTop;
        let viewportSize = axis === 'x' ? thumbWrapper.clientWidth : thumbWrapper.clientHeight;
        let renderableThumbs = getRenderableThumbItems();

        for (let i = 0; i < renderableThumbs.length; i++) {
          let bounds = getThumbBoundsOnAxis(renderableThumbs[i], axis);
          if (bounds.end > currentScroll + 1 && bounds.start < currentScroll + viewportSize - 1) {
            return {
              thumb: renderableThumbs[i],
              index: i,
              items: renderableThumbs
            };
          }
        }

        return null;
      }

      function setThumbScroll(nextScroll, axis, behavior) {
        if (!thumbWrapper) return;

        if (axis === 'x') {
          try {
            thumbWrapper.scrollTo({ left: nextScroll, behavior: behavior });
          } catch (_) {
            thumbWrapper.scrollLeft = nextScroll;
          }
        } else {
          try {
            thumbWrapper.scrollTo({ top: nextScroll, behavior: behavior });
          } catch (_) {
            thumbWrapper.scrollTop = nextScroll;
          }
        }
      }

      function scrollThumbIntoAxis(targetThumb, axis, behavior) {
        if (!thumbWrapper || !targetThumb || !canScrollOnAxis(axis)) return false;
        let safeBehavior = behavior === 'auto' ? 'auto' : 'smooth';
        let currentScroll = axis === 'x' ? thumbWrapper.scrollLeft : thumbWrapper.scrollTop;
        let viewportSize = axis === 'x' ? thumbWrapper.clientWidth : thumbWrapper.clientHeight;
        let bounds = getThumbBoundsOnAxis(targetThumb, axis);
        let thumbStart = bounds.start;
        let thumbEnd = bounds.end;
        let viewportEnd = currentScroll + viewportSize;
        let nextScroll = currentScroll;

        if (thumbStart < currentScroll) {
          nextScroll = thumbStart - SCROLL_PADDING;
        } else if (thumbEnd > viewportEnd) {
          nextScroll = thumbEnd - viewportSize + SCROLL_PADDING;
        }

        let maxScroll = axis === 'x'
          ? Math.max(0, thumbWrapper.scrollWidth - thumbWrapper.clientWidth)
          : Math.max(0, thumbWrapper.scrollHeight - thumbWrapper.clientHeight);

        nextScroll = Math.min(maxScroll, Math.max(0, nextScroll));
        if (Math.abs(nextScroll - currentScroll) < 1) return false;
        setThumbScroll(nextScroll, axis, safeBehavior);
        return true;
      }

      function isThumbVisible(targetThumb) {
        if (!thumbWrapper || !targetThumb) return true;

        let wrapperRect = thumbWrapper.getBoundingClientRect();
        let itemRect = targetThumb.getBoundingClientRect();

        return (
          itemRect.left >= wrapperRect.left - 1 &&
          itemRect.right <= wrapperRect.right + 1 &&
          itemRect.top >= wrapperRect.top - 1 &&
          itemRect.bottom <= wrapperRect.bottom + 1
        );
      }

      function ensureThumbVisible(targetThumb, behavior) {
        if (!thumbWrapper || !targetThumb) return;

        let axis = getScrollAxis();
        let altAxis = axis === 'x' ? 'y' : 'x';
        let safeBehavior = behavior === 'auto' ? 'auto' : 'smooth';

        scrollThumbIntoAxis(targetThumb, axis, safeBehavior);

        // Fallback: if still not visible, try the opposite axis once.
        requestAnimationFrame(function () {
          if (!isThumbVisible(targetThumb)) {
            scrollThumbIntoAxis(targetThumb, altAxis, safeBehavior);
          }
        });
      }

      function syncThumbActive(targetThumb, behavior = 'smooth') {
        let thumbItems = getThumbItems();
        thumbItems.forEach(function (item) {
          item.classList.remove('is-nav-selected');
        });

        if (!targetThumb) return;
        targetThumb.classList.add('is-nav-selected');
        requestAnimationFrame(function () {
          ensureThumbVisible(targetThumb, behavior);
        });
      }

      function getThumbByMainIndex(index) {
        let currentCell = getCurrentMainCell(index);
        let currentMediaId = getMediaIdFromMainCell(currentCell);
        let currentThumb = getThumbByMediaId(currentMediaId);
        if (currentThumb) return currentThumb;

        if (typeof index === 'number' && typeof mainSliderInstance.getCellElements === 'function') {
          let mediaIdByIndex = getMediaIdFromMainCell(mainSliderInstance.getCellElements()[index]);
          let thumbByIndexMedia = getThumbByMediaId(mediaIdByIndex);
          if (thumbByIndexMedia) return thumbByIndexMedia;
        }

        let thumbItems = getRenderableThumbItems();
        return thumbItems[index] || null;
      }

      function getMainIndexByThumb(thumb) {
        if (!thumb) return -1;

        let dataImage = thumb.getAttribute('data-image');
        if (dataImage && typeof mainSliderInstance.getCellElements === 'function') {
          let mediaId = dataImage.replace('media-', 'media-main-');
          let targetCell = mainSlider.querySelector('[id="' + mediaId + '"]');
          if (targetCell) {
            let cells = mainSliderInstance.getCellElements();
            let cellIndex = cells.indexOf(targetCell);
            if (cellIndex > -1) return cellIndex;
          }
        }

        return getThumbItems().indexOf(thumb);
      }

      getThumbItems().forEach(function (thumb) {
        if (thumb.__thumbNavClickHandler) {
          thumb.removeEventListener('click', thumb.__thumbNavClickHandler);
        }

        thumb.__thumbNavClickHandler = function () {
          let targetIndex = getMainIndexByThumb(thumb);
          if (targetIndex < 0) return;

          // UX tweak: when current visible first thumb still has previous items,
          // clicking it should scroll thumbnails backward without changing main media.
          let currentIndex = mainSliderInstance.selectedIndex;
          if (targetIndex === currentIndex && thumb.classList.contains('is-nav-selected')) {
            let firstVisible = getFirstVisibleThumbInfo();
            if (firstVisible && firstVisible.thumb === thumb && firstVisible.index > 0) {
              let prevThumb = firstVisible.items[firstVisible.index - 1];
              ensureThumbVisible(prevThumb, 'smooth');
              return;
            }
          }

          mainSliderInstance.select(targetIndex, true);
          syncThumbActive(thumb, 'smooth');
        };

        thumb.addEventListener('click', thumb.__thumbNavClickHandler);
      });

      if (
        thumbContainer.__thumbNavSlider &&
        thumbContainer.__thumbNavChangeHandler &&
        typeof thumbContainer.__thumbNavSlider.off === 'function'
      ) {
        thumbContainer.__thumbNavSlider.off('change', thumbContainer.__thumbNavChangeHandler);
      }
      if (
        thumbContainer.__thumbNavSlider &&
        thumbContainer.__thumbNavSettleHandler &&
        typeof thumbContainer.__thumbNavSlider.off === 'function'
      ) {
        thumbContainer.__thumbNavSlider.off('settle', thumbContainer.__thumbNavSettleHandler);
      }

      thumbContainer.__thumbNavSlider = mainSliderInstance;
      thumbContainer.__thumbNavChangeHandler = function (index) {
        let targetThumb = getThumbByMainIndex(index);
        syncThumbActive(targetThumb, 'smooth');
      };
      thumbContainer.__thumbNavSettleHandler = function (index) {
        let targetThumb = getThumbByMainIndex(index);
        syncThumbActive(targetThumb, 'smooth');
      };

      mainSliderInstance.on('change', thumbContainer.__thumbNavChangeHandler);
      mainSliderInstance.on('settle', thumbContainer.__thumbNavSettleHandler);
      syncThumbActive(getThumbByMainIndex(mainSliderInstance.selectedIndex || 0), 'auto');
    });
  }

  function onLoad(section = document) {
    initProductSlider(section);
    initProductThumbSlider(section);
    initThumbNav(section);
    if (typeof findVisibleItems === 'function') {
      findVisibleItems();
    }
    productZoomInit();
    sizeChart();
    initStickyAddToCart();
    load3DModel();
    onReadyEvent();
  }

  $(document).ready(function () {
    onLoad(document);

    function playVideo() {
      currentVideo = $('[data-reel-content] video')[0];
      if (currentVideo) {
        currentVideo.load();
        currentVideo.play();
      }
    }

    function pauseVideo() {
      if (currentVideo) {
        currentVideo.pause();
      }
    }
  });

  return {
    initProductSlider,
    initProductThumbSlider,
    initThumbNav
  };
})();

if (document.querySelector('[data-flickity-product-slider]')) {
  window.addEventListener('resize', function (event) {
    Theme.Product.initProductSlider();
    Theme.Product.initProductThumbSlider();
    Theme.Product.initThumbNav();
    if (typeof findVisibleItems === 'function') {
      findVisibleItems();
    }
  });
}
